import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import type { SettingView } from '@shared/schemas/setting';

/* The queries behind /admin/settings — business-rules.md §2. */

const ROOT = ['admin', 'settings'] as const;

export function useSettings() {
  return useQuery({
    queryKey: ROOT,
    queryFn: () => api.get<{ data: SettingView[] }>('/api/admin/settings'),
  });
}

export function useUpdateSetting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: { key: string; value: unknown }) =>
      api.patch<SettingView>('/api/admin/settings', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ROOT }),
  });
}
